import { useTabster } from './useTabster';
import { getObservedElement } from 'tabster';
import { useTabsterAttributes } from './useTabsterAttributes';
export function useObservedElement(name) {
    const tabster = useTabster();
    if (tabster) {
        getObservedElement(tabster);
    }
    return useTabsterAttributes({
        observed: {
            names: Array.isArray(name) ? name : [
                name
            ]
        }
    });
}
